import { Typography } from "@mui/material";

export const AzureDevOpsFormattedDestination = ({
  projectTitle,
}: {
  projectTitle: string;
}) => {
  return <Typography>{projectTitle}</Typography>;
};
